//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import codeImg from '@/static/picture/code.png';
import moment from "moment";
import { MessageBox } from "element-ui";
export default {
  props: {
    showLayer: Boolean,
    // typeName: String
  },
  computed: {
    showIntLayer: {
      get () {
        return this.showLayer  // 默认是近似选中
      },
      set (val) {
        this.$emit("update:showLayer", val);
      }
    }
  },
 /* watch: {
    typeName(newVal) {
      if (newVal === 'indexReg') {
        this.isRegister = true;
      } else {
        this.isRegister = false;
      }
    }
  },*/
  data(){
    return {
      // isRegister: false, // 是否是注册
      loginOk: false, // 是否登录成功
      // wx_token: '', //是否微信授权成功
      tabType: 'wx'
    }
  },
  mounted(){
    /*let wxToken = this.$route.query.wx_token;
    if(wxToken){
      this.$nextTick(() => {
        this.showIntLayer = true;
      });
      this.wx_token = wxToken;
    }*/
  },
  methods: {
    // tab 切换事件
    handlerLoginType(){
      // console.log(val)
      this.loginOk = false;
      if(this.tabType === 'code'){
        this.$nextTick(() => {
          this.$refs.codeRef.getPicCode()
        })
      } else if(this.tabType === 'pwd'){
        this.$nextTick(() => {
          this.$refs.pwdRef.getPicCode()
        })
      }
    },
    // 免费注册
    loginRegisterEnter(){
      this.tabType = 'wx';
    },
    wxLoginSuccess(){
      this.showIntLayer = false;
      window.location.reload(); // 刷新当前页面
    },
    // 关闭弹框
    closeLayer(type){
      this.showIntLayer = false;
      this.$emit('close', type);
      if(this.$refs.pwdRef)this.$refs.pwdRef.resetForm();
      if(this.$refs.codeRef)this.$refs.codeRef.resetForm();
      if(this.$refs.registerRef)this.$refs.registerRef.resetForm();
      // this.isRegister = false;
      // this.wx_token = '';
    },
    // 密码登录 | 验证码登录
    onSubmit(JSONParams){
      this.loginOk = true;
      this.$axios.post("/api/Auth/login", JSONParams).then(res => {
        this.loginOk = false;
        if (res.data.code === 0) {
          let backData = res.data.data;
          this.renewNotice(backData); // 续费通知
          localStorage.setItem("uc_token", backData.uc_token) // 登录后保存token
          this.closeLayer('refresh')
          //成功 -- 同步登录
          /*if (this.queryPam && this.queryPam.jump && this.queryPam.jump.indexOf("popularize") > -1) {
            this.$router.push("/popularize");
          } else if (this.queryPam && this.queryPam.jump) {
            this.$router.push(this.queryPam.jump);
          } else {
            console.log(132465)
            this.$router.push("/");
          }*/
        } else {
          this.$refs.pwdRef.loginForm.graphCode = '';
          if(this.tabType === 'pwd') {
            this.$refs.pwdRef.getPicCode()
          } else {
            this.$refs.codeRef.getPicCode()
          }
          this.$message.closeAll();
          this.$message.error(res.data.msg);
        }

      }).catch(e=> {
        if(this.tabType === 'pwd') {
          this.$refs.pwdRef.getPicCode()
        } else {
          this.$refs.codeRef.getPicCode()
        }
        this.loginOk = false;
      })
    },
    // 微信授权成功后，录入手机号码
   /* onWxSubmit(JSONParams){
      this.$axios.post("/api/Auth/wxBindMobile", JSONParams).then(res => {
        if (res.data.code === 0) {
          let backData = res.data.data;
          this.renewNotice(backData); // 续费通知
          localStorage.setItem("uc_token", backData.uc_token) // 微信登录后绑定手机后保存token
          this.clearWxTokenParam();
          // this.closeLayer('refresh');
        } else {
          this.$message.closeAll();
          this.$message.error(res.data.msg);
        }
        this.$refs.codeRef.getPicCode()
      }).catch(e=> {
        this.$refs.codeRef.getPicCode()
      })
    },*/
    // 只清除wx_token参数的方法
   /* clearWxTokenParam() {
      const url = new URL(window.location);
      // url.searchParams.delete('wx_token');
      window.history.replaceState({}, document.title, url);
      window.location.reload();
    },*/
    // 续费通知
    renewNotice(data){
      let fortyDaysAgo = moment(data.uc_vip_exp).subtract(39, 'days').format('YYYY-MM-DD'); // 到期前40天
      let thirtyDaysAgo = moment(data.uc_vip_exp).subtract(29, 'days').format('YYYY-MM-DD'); // 到期前30天
      let tenDaysAgo = moment(data.uc_vip_exp).subtract(9, 'days').format('YYYY-MM-DD'); // 到期前10天
      let day = moment().startOf("day").format('YYYY-MM-DD'); //今天的时间
      let dueTimeTip = this.$cookies.get("dueTimeTip");
      if(day === fortyDaysAgo || day === thirtyDaysAgo || day === tenDaysAgo){
        if(dueTimeTip) return
        this.$axios.get("/api/Inmail/renewNotice").then(res => {
          this.$cookies.set("dueTimeTip", true);
          if(res.data.data.length === 0) return
          MessageBox.alert(`<p>${res.data.data.content}</p><div class="codeImgTip"><img src="${codeImg}"/></div>`, '提示', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '了解更多',
            center: true,
            type: 'warning',
            customClass: 'commonTip'
          }).then(()=> {
            this.$router.push({
              path:"/user/VersionIntroduction",
            })
          });
        })
      } else {
        this.$cookies.set("dueTimeTip", false);
      }
    }
  }
}
